import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b532729a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "" }

import Text from "@/core/uni-components/Text.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'EstimateBadge',
  props: {
  badge: {
    type: String,
  },
  bgColor: {
    type: String,
    default: "#6B5F4B",
  },
},
  setup(__props) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "estimate_badge",
    style: _normalizeStyle({ backgroundColor: __props.bgColor })
  }, [
    _createElementVNode("p", _hoisted_1, _toDisplayString(__props.badge), 1)
  ], 4))
}
}

})